import { useEffect, useState } from "react";
import { Table } from "antd";
import SkeletonTable from "@/components/Skeletons/SkeletonTable.jsx";

const CustomTable = ({
  tableData,
  isTableLoading,
  tableHeaders,
  onRowClick,
  rowSelectionType,
  onRowSelect,
  onTableChange,
  clearSelection,
  setClearSelection,
}) => {
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    if (clearSelection) {
      setSelectedRowKeys([]);

      if (setClearSelection) setClearSelection(false);
    }

    /* eslint-disable-next-line */
  }, [clearSelection]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      onRowSelect?.(selectedRows);
      setSelectedRowKeys(selectedRowKeys);
    },
  };
  const handlePaginationChange = (page, pageSize) => {
    setPagination({
      pageNumber: page,
      pageSize,
    });
  };

  if (isTableLoading) return <SkeletonTable columns={tableHeaders} />;

  if (rowSelectionType?.length > 0)
    return (
      <Table
        rowKey="id"
        rowClassName="cursor-pointer"
        className="w-full"
        columns={tableHeaders || []}
        dataSource={tableData || []}
        onRow={(record) => {
          return {
            onClick: () => onRowClick?.(record), // click row
          };
        }}
        onChange={(pagination, filters, sorter) => {
          if (onTableChange) {
            onTableChange(pagination, filters, sorter);
          }
        }}
        scroll={{ x: "max-content" }}
        pagination={{
          size: "small",
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: [5, 10, 50],
          current: pagination.pageNumber,
          pageSize: pagination.pageSize,
          onChange: handlePaginationChange,
          showTotal: (total) => `Total ${total} Items`,
          total: tableData?.length || 0,
        }}
        rowSelection={{
          type: rowSelectionType,
          ...rowSelection,
        }}
      />
    );

  return (
    <Table
      rowKey="id"
      rowClassName="cursor-pointer"
      className="w-full"
      columns={tableHeaders || []}
      dataSource={tableData || []}
      onRow={(record) => {
        return {
          onClick: () => onRowClick?.(record), // click row
        };
      }}
      scroll={{ x: "max-content" }}
      pagination={{
        size: "small",
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 50],
        current: pagination.pageNumber,
        pageSize: pagination.pageSize,
        onChange: handlePaginationChange,
        showTotal: (total) => `Total ${total} Items`,
        total: tableData?.length || 0,
      }}
    />
  );
};

export default CustomTable;
